import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import moment from "moment";
import Select from "../../components/Select";

export default function EditTransactionModal({ show, onHide, transaction, lookups, onSave }) {
    const [categoryId, setCategoryId] = useState(null);
    const [tags, setTags] = useState([]);
    const [remarks, setRemarks] = useState("");
    const [date, setDate] = useState("");

    useEffect(() => {
        if (transaction) {
            setCategoryId(transaction.categoryId);
            setTags(transaction.tags || []);
            setRemarks(transaction.remarks || "");
            setDate(moment(transaction.time).format("YYYY-MM-DD"));
        }
    }, [transaction]);

    const handleSave = () => {
        onSave({
            id: transaction.id,
            type: transaction.type,
            categoryId,
            tags,
            remarks,
            date
        });
        onHide();
    };

    const handleClose = () => {
        onHide();
    };

    return (
        <Modal show={show} onHide={handleClose} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title style={{ direction: "rtl" }}>
                    עריכת פעולה - {transaction?.description}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ direction: "rtl", padding: "30px" }}>
                <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ marginBottom: "15px", fontWeight: "bold" }}>תאריך</h5>
                    <Form.Control
                        type="date"
                        value={date}
                        onChange={(e) => setDate(e.target.value)}
                        style={{ width: "auto" }}
                    />
                </div>

                <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ marginBottom: "15px", fontWeight: "bold" }}>קטגוריה</h5>
                    <Select
                        options={lookups?.categories || []}
                        selected={categoryId}
                        onSelect={setCategoryId}
                        closeOnSelect={true}
                        placeholder="בחר קטגוריה"
                        isSearchable={true}
                    />
                </div>

                <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ marginBottom: "15px", fontWeight: "bold" }}>תגיות</h5>
                    <Select
                        options={lookups?.tags || []}
                        selected={tags}
                        onSelect={setTags}
                        multi={true}
                        placeholder="בחר תגיות"
                        isSearchable={true}
                    />
                </div>

                <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ marginBottom: "15px", fontWeight: "bold" }}>הערות</h5>
                    <Form.Control
                        style={{ resize: "none" }}
                        value={remarks}
                        as="textarea"
                        rows={3}
                        onChange={(e) => setRemarks(e.target.value)}
                    />
                </div>
            </Modal.Body>
            <Modal.Footer style={{ direction: "rtl" }}>
                <Button variant="secondary" onClick={handleClose}>
                    ביטול
                </Button>
                <Button variant="primary" onClick={handleSave}>
                    שמור שינויים
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
